import { useProgressiveImage } from '@hooks/useProgessiveImage'
import { classNames } from '@utils/genUtils'
import { imageBridgeHelper } from '@utils/imageUtils'
import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React, { memo, useEffect, useState } from 'react'
import { useIntersectionObserver } from 'react-intersection-observer-hook'

interface Props {
  showBlurImage: boolean
  gatsbyDataImg?: IGatsbyImageData | null
  onLoad?: () => void
  bgImageClasses?: string
  bgSrcClasses?: string
}

function BackgroundImageLoader(props: Props) {
  const { showBlurImage, gatsbyDataImg, bgImageClasses, bgSrcClasses } = props
  const [isVisible, setIsVisible] = useState(false)
  const [ref, { entry, rootRef }] = useIntersectionObserver();
  const image = gatsbyDataImg ? getImage(gatsbyDataImg) : null
  const bgImage = imageBridgeHelper(image)
  const srcLoaded = useProgressiveImage(bgImage, isVisible)
  useEffect(() => {
    if (entry && entry.isIntersecting && !isVisible) {
      setIsVisible(true)
      // console.log(`The component is visible.`);
    } else {
      // console.log(`The component is not visible.`);
    }
  }, [entry]);

  useEffect(() => {
    if (srcLoaded) {
      props.onLoad && props.onLoad()
    }
  }, [srcLoaded])
  return (
    <div className={classNames('absolute top-0 left-0 w-full', bgImageClasses ? bgImageClasses : 'h-full')}>
      <div
        ref={ref}
        style={{
          backgroundImage: `url(${showBlurImage && bgImage ? bgImage.fluid?.base64 : ''})`,
        }}
        className={classNames('bg-image-blur absolute top-0 left-0 w-full h-full bg-center bg-no-repeat bg-cover z-1', bgSrcClasses ? bgSrcClasses : '')}>
      </div>
      {(srcLoaded) && <div
        style={{
          backgroundImage: `url(${bgImage?.fluid?.src})`,
        }}
        className={classNames('bg-image absolute top-0 left-0 w-full h-full overflow-hidden bg-center bg-no-repeat bg-cover z-2 transition-opacity animate-fadeIn', bgSrcClasses ? bgSrcClasses : '')}
      >
      </div>}
    </div>
  )
}

export default BackgroundImageLoader
